import { CheckCircle, Warning } from "@phosphor-icons/react";

export default function EvalDetail({ result, drawingImg }) {
  const status   = result.overall_status;
  const issues   = result.issues || [];
  const compliant = result.compliant_elements || [];
  const refs     = result.references || [];

  return (
    <div className="p-4 space-y-4">
      <div className="flex gap-4">
        {drawingImg && (
          <div className="flex-shrink-0 w-32 h-24 bg-slate-100 rounded overflow-hidden border border-slate-200">
            <img src={`data:image/jpeg;base64,${drawingImg}`} alt="Drawing" className="w-full h-full object-contain" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className={`inline-flex items-center gap-1.5 px-2 py-1 rounded text-sm font-semibold mb-2 ${
            status === "COMPLIANT" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
          }`}>
            {status === "COMPLIANT" ? <CheckCircle size={14} weight="fill" /> : <Warning size={14} weight="fill" />}
            {status}
          </div>
          {result.summary && <p className="text-sm text-slate-600 leading-relaxed">{result.summary}</p>}
        </div>
      </div>

      {issues.length > 0 && (
        <div>
          <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Issues ({issues.length})</h3>
          <div className="space-y-1.5">
            {issues.map((issue, i) => {
              const isCrit = issue.startsWith("CRITICAL");
              const isMaj  = issue.startsWith("MAJOR");
              return (
                <div key={i} className={`text-xs px-3 py-2 rounded border-l-2 ${
                  isCrit ? "border-red-500 bg-red-50 text-red-800"
                  : isMaj ? "border-amber-500 bg-amber-50 text-amber-800"
                  : "border-blue-400 bg-blue-50 text-blue-800"
                }`}>{issue}</div>
              );
            })}
          </div>
        </div>
      )}

      {compliant.length > 0 && (
        <div>
          <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Compliant Elements</h3>
          <div className="space-y-1">
            {compliant.map((el, i) => (
              <div key={i} className="flex items-start gap-2 text-xs text-slate-600">
                <CheckCircle size={12} className="text-green-500 mt-0.5 flex-shrink-0" />
                {el}
              </div>
            ))}
          </div>
        </div>
      )}

      {refs.length > 0 && (
        <div>
          <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">References</h3>
          <div className="space-y-1">
            {refs.map((r, i) => <p key={i} className="text-xs text-slate-500 font-mono">{r}</p>)}
          </div>
        </div>
      )}
    </div>
  );
}
